var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100Mic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7999 11.6776C13.7999 12.7479 12.9959 13.6118 11.9999 13.6118C11.0039 13.6118 10.1999 12.7479 10.1999 11.6776V7.80921C10.1999 6.73895 11.0039 5.875 11.9999 5.875C12.9959 5.875 13.7999 6.73895 13.7999 7.80921V11.6776ZM11.9999 7.16447C11.6699 7.16447 11.3999 7.45461 11.3999 7.80921V11.6776C11.3999 12.0322 11.6699 12.3224 11.9999 12.3224C12.3299 12.3224 12.5999 12.0322 12.5999 11.6776V7.80921C12.5999 7.45461 12.3299 7.16447 11.9999 7.16447ZM12 14.9013C13.656 14.9013 15 13.4571 15 11.6776H16.2C16.2 13.9536 14.634 15.8233 12.6 16.1392V18.125H11.4V16.1392C9.36601 15.8233 7.80001 13.9536 7.80001 11.6776H9.00001C9.00001 13.4571 10.344 14.9013 12 14.9013Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100Mic);
export default __webpack_public_path__ + "static/media/100-mic.ef0721a51b07aa4c2f1fb81adc24b182.svg";
export { ForwardRef as ReactComponent };